"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FORM_SUBMIT = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _entries = require("babel-runtime/core-js/object/entries");

var _entries2 = _interopRequireDefault(_entries);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

exports.onSubmitActions = onSubmitActions;
exports.onSubmitUpdateActions = onSubmitUpdateActions;

var _utilityFunctions = require("utils/utilityFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// gapiBaseURL is a global (defined with webpack's definePlugin)

// Thieved from https://github.com/yelouafi/redux-saga/issues/161#issuecomment-229350795
//
// A redux-form form uses onSubmitActions (reduxFormSubmitActions.js) to provide 3 actions:
//  - submitAction for the form to dispatch on submit
//  - sucessAction for formSubmitSaga to listen for if the form submit should succeed,
//  - failureAction for formSubmitSaga to listen for if the form submit should fail
//
// The form is then returned a promise (which redux-form expects for server-side validation) that
//  either gets resolved or rejected if the successAction or failureAction are dispatched respectively
//  (from listenForReduxFormSubmit and formSubmitSaga (listenForReduxFormSubmit.js) which
//  listen for these actions in submitAction then successAction/failureAction flow order)

var FORM_SUBMIT = exports.FORM_SUBMIT = "redux-form-submit-actions/FORM_SUBMIT";

function formSubmit(submitAction, successAction, failureAction, values, resolve, reject) {
    return {
        type: FORM_SUBMIT,
        payload: {
            submitAction: submitAction,
            successAction: successAction,
            failureAction: failureAction,
            values: values,
            resolve: resolve,
            reject: reject
        }
    };
}

function onSubmitActions(submitAction, successAction, failureAction) {
    return function (values, dispatch) {
        return new _promise2.default(function (resolve, reject) {
            dispatch(formSubmit(submitAction, successAction, failureAction, values, resolve, reject));
        });
    };
}

// We pass initialValues for the form's onSubmit to only dispatch the changed values
function onSubmitUpdateActions(submitAction, successAction, failureAction) {
    return function (initialValues) {
        return function (values, dispatch) {
            return new _promise2.default(function (resolve, reject) {
                var resourceDelta = (0, _utilityFunctions.objectDelta)(initialValues, values);
                var toPatch = (0, _objectWithoutProperties3.default)(resourceDelta, []);

                resourceDelta.toDelete = [];

                // Rooming Information Page:
                // The Rooming Suggester currently does not set the rooming approval status in Compass to `true`.
                // As a workaround, users can re-submit the unchanged form to flip the approval flag themselves.
                // NOTE: This is a frontend workaround. The proper fix should be on the backend-side: when the Rooming Suggester
                // assigns rooms, it should emit an approval request automatically.
                if ((0, _entries2.default)(toPatch).length === 0) {
                    (0, _keys2.default)(initialValues).forEach(function (href) {
                        if (href.includes("/rooming_requests/")) {
                            var requestPayload = (0, _defineProperty3.default)({}, href, { bed_type: initialValues[href].bed_type });
                            dispatch(formSubmit(submitAction, successAction, failureAction, requestPayload, resolve, reject));
                        }
                    });
                }

                // If any change in toPost from initialValues, grab entire resource to POST it
                // Entire resource is available in values.toPost but not in resourceDelta.toPost
                // (necessary for things like flight_resources where you need to initialize values and
                //  only want to go ahead and POST everything if a user makes a change to the form.
                //  These changes appear by themselves without the initialized values so we need to grab them manually.)
                // The resourceDelta will only contain segments data, but we also need the rest of the payload
                if (resourceDelta.toPost) {
                    resourceDelta.toPost = (0, _keys2.default)(resourceDelta.toPost).reduce(function (newToPost, postHref) {
                        newToPost[postHref] = (0, _keys2.default)(resourceDelta.toPost[postHref]).reduce(function (newPostResource, tempId) {
                            newPostResource[tempId] = (0, _extends3.default)({}, values.toPost[postHref][tempId]);
                            return newPostResource;
                        }, {});
                        return newToPost;
                    }, {});
                }

                if (resourceDelta.toPost) {
                    (0, _keys2.default)(resourceDelta.toPost).forEach(function (postHref) {
                        if (postHref.includes("/rooming_requests")) {
                            (0, _keys2.default)(resourceDelta.toPost[postHref]).forEach(function (key) {
                                if (resourceDelta.toPost[postHref][key].customers) {
                                    var customersIds = resourceDelta.toPost[postHref][key].customers.map(function (x) {
                                        return x.id;
                                    });
                                    if (customersIds && customersIds.includes(0)) {
                                        var newCustomers = resourceDelta.toPost[postHref][key].customers.filter(function (customer) {
                                            return customer.id != 0;
                                        });
                                        resourceDelta.toPost[postHref][key].customers = newCustomers;
                                        resourceDelta.toPost[postHref][key].flags = ["REQUEST_STRANGER"];
                                    }
                                }
                            });
                        }
                    });
                }
                // Flights
                (0, _keys2.default)(toPatch).forEach(function (patchHref) {
                    if (patchHref.includes("/flight_statuses/")) {
                        // grab the whole thing like we do for POSTs because of the dumb way we handle flight PATCHes
                        // (because segments isn't patchable - talk to @ammaare)
                        resourceDelta[patchHref] = (0, _extends3.default)({}, values[patchHref]);
                    }
                });

                // Rooming
                (0, _keys2.default)(toPatch).forEach(function (patchHref) {
                    if (patchHref.includes("/rooming_requests")) {
                        if (toPatch[patchHref].customers) {
                            var customersIds = toPatch[patchHref].customers.map(function (x) {
                                return x.id;
                            });
                            if (customersIds && customersIds.includes(0)) {
                                var newCustomers = toPatch[patchHref].customers.filter(function (customer) {
                                    return customer.id != 0;
                                });
                                resourceDelta[patchHref].customers = newCustomers;
                                resourceDelta[patchHref].flags = ["REQUEST_STRANGER"];
                            }
                        }
                        if (toPatch[patchHref].approved_by && toPatch[patchHref].approved_by.toDelete) {
                            resourceDelta[patchHref].customers = [{
                                id: toPatch[patchHref].approved_by.toDelete
                            }];
                            resourceDelta[patchHref].approved_by = [{
                                id: toPatch[patchHref].approved_by.toDelete
                            }];
                            resourceDelta[patchHref].flags = ["REQUEST_STRANGER"];
                            resourceDelta[patchHref].bed_type = {
                                name: "Twin"
                            };
                        }
                    }
                });

                // SHI-1076: When a JACKET_SIZE override is being POSTed in the same submit,
                // the override is the source of truth — any pending jacket_sizes change on
                // departure_services must be dropped. Without this, a user who edits the
                // size and then checks "Traveller does not require an Expedition Parka"
                // before saving persists both the new size AND the override, leaving the
                // backend in a contradictory state on the next fetch.
                var isApplyingJacketSizeOverride = resourceDelta.toPost && (0, _keys2.default)(resourceDelta.toPost).some(function (postHref) {
                    return postHref.includes(gapiBaseURL + "/overrides") && (0, _keys2.default)(resourceDelta.toPost[postHref]).some(function (tempId) {
                        var override = resourceDelta.toPost[postHref][tempId];
                        return override && override.requirement && override.requirement.code === 'JACKET_SIZE' && override.reason && override.reason.code;
                    });
                });
                if (isApplyingJacketSizeOverride) {
                    (0, _keys2.default)(resourceDelta).forEach(function (href) {
                        if (href.includes('/departure_services/') && resourceDelta[href] && 'jacket_sizes' in resourceDelta[href]) {
                            delete resourceDelta[href].jacket_sizes;
                            if ((0, _keys2.default)(resourceDelta[href]).length === 0) {
                                delete resourceDelta[href];
                            }
                        }
                    });
                }

                // Empty strings need to be turned into null for the API apparently...
                (0, _utilityFunctions.fixEmptyString)(resourceDelta);

                // DELETE for overrides
                (0, _keys2.default)(resourceDelta).forEach(function (resourceHref) {
                    if (resourceHref.includes(gapiBaseURL + "/overrides") && resourceDelta[resourceHref] && resourceDelta[resourceHref].reason && resourceDelta[resourceHref].reason.code === null) {
                        resourceDelta.toDelete.push(resourceHref);
                        delete resourceDelta[resourceHref];
                    }
                });

                dispatch(formSubmit(submitAction, successAction, failureAction, resourceDelta, resolve, reject));
            });
        };
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/reduxFormSubmitActions.js
// module id = 204
// module chunks = 0